const datalanguage =
    {
        es: {
            dataLabels: {
                first:{
                    nombres:'Nombre Completo:',
                    tipo_identificacion: 'Tipo de identificación:',
                    nit: 'ID / Cédula:',
                    sexo:'Género:',
                    fecha_cumple_ter:'Fecha de nacimiento:'
                },
                last:{
                    ciudad:'Ciudad:',
                    direccion:'Dirección:',
                    mail:'Correo electrónico:',
                    celular:'Número de celular/movil:',
                    country: 'País'
                }
            }
        },
        en: {
            dataLabels: {
                first:{
                    nombres:'undefined',
                    tipo_identificacion: 'undefined',
                    nit: 'undefined',
                    sexo:'undefined',
                    fecha_cumple_ter:'undefined'
                },
                last:{
                    ciudad:'undefined',
                    direccion:'undefined',
                    mail:'undefined',
                    celular:'undefined'
                }
            }
        }
    }
export default datalanguage;
/*
const datalanguage =
    {
        es: {
            dataLabels: {
                first: {
                    fullName: 'Nombre Completo:',
                    idType: 'Tipo de identificación:',
                    cedula: 'ID / Cédula:',
                    gender: 'Género:',
                    dateOfBirth: 'Fecha de nacimiento:'
                },
                last: {
                    city: 'Ciudad:',
                    direccion: 'Dirección:',
                    mail: 'Correo electrónico:',
                    telefono: 'Número de celular/movil:'
                }
            }
        },
        en: {
            dataLabels: {
                first: {
                    fullName: 'undefined',
                    idType: 'undefined',
                    cedula: 'undefined',
                    gender: 'undefined',
                    dateOfBirth: 'undefined'
                },
                last: {
                    city: 'undefined',
                    direccion: 'undefined',
                    mail: 'undefined',
                    telefono: 'undefined'
                }
            }
        }
    }
    export default datalanguage;*/
